import { useState, useEffect } from 'react';
export default function useLeaderboardData(url, apiToken, refreshInterval) {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), data = _b[0], setData = _b[1];
    var _c = useState(''), error = _c[0], setError = _c[1];
    useEffect(function () {
        setLoading(true);
        setData(null);
        var controller = new AbortController();
        var signal = controller.signal;
        var headers = undefined;
        if (apiToken) {
            headers = new Headers({
                Authorization: apiToken
            });
        }
        var fetchData = function () {
            fetch(url, { signal: signal, headers: headers })
                .then(function (response) { return response.json(); })
                .then(function (response) { return setData(response.data || null); })["catch"](function (error) { return setError(error); })["finally"](function () { return setLoading(false); });
        };
        fetchData();
        var intervalId;
        if (refreshInterval) {
            intervalId = setInterval(function () {
                fetchData();
            }, refreshInterval);
        }
        return function () {
            controller.abort();
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [url, apiToken, refreshInterval]);
    return { data: data, error: error, loading: loading };
}
